/* ============================================================
   LulaDream - Global JavaScript
   Core functionality for the theme
   ============================================================ */

/* ---- Intersection Observer for Reveal Animations ---- */
(function() {
  'use strict';

  const revealElements = document.querySelectorAll('.reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    revealElements.forEach(function(el) {
      observer.observe(el);
    });
  }
})();

/* ---- Accordion Component ---- */
class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.triggers = this.querySelectorAll('.accordion__trigger');
    this.allowMultiple = this.hasAttribute('data-allow-multiple');
    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach(function(trigger) {
      trigger.addEventListener('click', this.toggle.bind(this));
    }.bind(this));
  }

  toggle(event) {
    var item = event.currentTarget.closest('.accordion__item');
    var isOpen = item.classList.contains('is-open');

    if (!this.allowMultiple) {
      this.querySelectorAll('.accordion__item.is-open').forEach(function(openItem) {
        openItem.classList.remove('is-open');
      });
    }

    if (!isOpen) {
      item.classList.add('is-open');
    }
  }
}
if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}

/* ---- Quantity Selector ---- */
class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.quantity-selector__input');
    this.minusBtn = this.querySelector('[data-action="minus"]');
    this.plusBtn = this.querySelector('[data-action="plus"]');
    this.min = parseInt(this.input.getAttribute('min')) || 1;
    this.max = parseInt(this.input.getAttribute('max')) || 99;
    this.bindEvents();
  }

  bindEvents() {
    this.minusBtn.addEventListener('click', this.decrease.bind(this));
    this.plusBtn.addEventListener('click', this.increase.bind(this));
    this.input.addEventListener('change', this.validate.bind(this));
  }

  decrease() {
    var value = parseInt(this.input.value) - 1;
    if (value >= this.min) {
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  increase() {
    var value = parseInt(this.input.value) + 1;
    if (value <= this.max) {
      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  validate() {
    var value = parseInt(this.input.value);
    if (isNaN(value) || value < this.min) this.input.value = this.min;
    if (value > this.max) this.input.value = this.max;
  }
}
if (!customElements.get('quantity-selector')) {
  customElements.define('quantity-selector', QuantitySelector);
}

/* ---- Purchase Options Toggle ---- */
class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll('.purchase-option');
    this.bindEvents();
  }

  bindEvents() {
    this.options.forEach(function(option) {
      option.addEventListener('click', this.select.bind(this, option));
    }.bind(this));
  }

  select(selectedOption) {
    this.options.forEach(function(option) {
      option.classList.remove('is-selected');
    });
    selectedOption.classList.add('is-selected');

    var input = selectedOption.querySelector('input[type="radio"]');
    if (input) input.checked = true;

    this.dispatchEvent(new CustomEvent('purchase-option-changed', {
      detail: { value: input ? input.value : null },
      bubbles: true
    }));
  }
}
if (!customElements.get('purchase-options')) {
  customElements.define('purchase-options', PurchaseOptions);
}

/* ---- Mobile Menu Toggle ---- */
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.trigger = document.querySelector('[data-mobile-menu-trigger]');
    this.overlay = document.querySelector('[data-mobile-menu-overlay]');
    this.closeBtn = this.querySelector('[data-mobile-menu-close]');
    this.isOpen = false;
    this.bindEvents();
  }

  bindEvents() {
    if (this.trigger) {
      this.trigger.addEventListener('click', this.toggle.bind(this));
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.classList.add('is-active');
    if (this.overlay) this.overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.isOpen = false;
    this.classList.remove('is-active');
    if (this.overlay) this.overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}
if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu);
}

/* ---- Cart Drawer ---- */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.closeBtn = this.querySelector('[data-cart-close]');
    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll('[data-cart-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', this.open.bind(this));
    }.bind(this));

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }
  }

  open() {
    this.classList.add('is-active');
    if (this.overlay) this.overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('is-active');
    if (this.overlay) this.overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  updateCart(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newContent = doc.querySelector('cart-drawer');
    if (newContent) {
      this.innerHTML = newContent.innerHTML;
    }
  }
}
if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

/* ---- Sticky Header ---- */
(function() {
  var header = document.querySelector('.header-wrapper');
  if (!header) return;

  var lastScroll = 0;
  var headerHeight = header.offsetHeight;

  window.addEventListener('scroll', function() {
    var currentScroll = window.pageYOffset;

    if (currentScroll > headerHeight) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

    if (currentScroll > lastScroll && currentScroll > headerHeight * 2) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }

    lastScroll = currentScroll;
  }, { passive: true });
})();

/* ---- Smooth Scroll for Anchor Links ---- */
document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
  anchor.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      var headerOffset = 80;
      var elementPosition = target.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  });
});

/* ---- Lazy Loading Images ---- */
if ('loading' in HTMLImageElement.prototype) {
  document.querySelectorAll('img[loading="lazy"]').forEach(function(img) {
    if (img.dataset.src) img.src = img.dataset.src;
  });
} else {
  var lazyImages = document.querySelectorAll('img[loading="lazy"]');
  if (lazyImages.length > 0 && 'IntersectionObserver' in window) {
    var imgObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          imgObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(function(img) { imgObserver.observe(img); });
  }
}
